
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","d":"M0 0h16v16H0z"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('mask',{attrs:{"id":"b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#a"}})]),_c('path',{attrs:{"fill":"#000","d":"M9.288 2.575A1.29 1.29 0 018 3.863a1.289 1.289 0 111.288-1.288m6.654 4.594L14.63 5.29a.32.32 0 00-.264-.138c-.1 0-.2.046-.264.138L12.79 7.17a.322.322 0 00.12.473c.127.063.287.133.47.195a5.378 5.378 0 01-1.562 3.363 5.385 5.385 0 01-2.852 1.494V7.726h.966a.643.643 0 000-1.287h-.966V4.963a2.577 2.577 0 001.61-2.388 2.575 2.575 0 10-3.541 2.388v1.476h-.967a.643.643 0 000 1.287h.966v4.968a5.383 5.383 0 01-2.852-1.495 5.382 5.382 0 01-1.563-3.362 3.71 3.71 0 00.47-.195.322.322 0 00.121-.473L1.898 5.29a.32.32 0 00-.264-.138c-.1 0-.2.046-.264.138L.058 7.169a.322.322 0 00.12.473c.136.067.308.142.506.206a7.33 7.33 0 006.35 6.8v.386a.966.966 0 001.932 0v-.385a7.313 7.313 0 004.218-2.084l-.001.001a7.311 7.311 0 002.133-4.718c.198-.064.37-.14.505-.206a.322.322 0 00.121-.473","mask":"url(#b)"}})])])
          )
        }
      }
    